import React, { Component } from 'react'
import styled from 'styled-components'

const Container = styled.div`
    margin: auto;
    width: 100%;
    text-align:center;
    max-width: 500px;
`

class Loading extends Component {
  render () {
    return (
      <Container>
        <h2>Loading...</h2>
      </Container>
    )
  }
}

export default Loading
